<div class="container-fluid">
  <app-pagetitle title="Operator Performance Report" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-xl-12">
      <div class="row">

        <!-- Department -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Department</label>
            <select class="form-control custom-select"
              [(ngModel)]="selectedDepartment"
              name="departmentName"
              (ngModelChange)="select_Department()">
              <option *ngFor="let dept of departmentData" [ngValue]="dept.departmentName">
                {{ dept.departmentName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Shift -->
        <div class="col-md-1">
          <div class="form-group">
            <label>Shift</label>
            <select class="form-control custom-select"
              [(ngModel)]="shiftName"
              name="shiftName"
              (ngModelChange)="onShiftChange($event)">
              <option *ngFor="let shift of shiftData" [ngValue]="shift.shiftName">
                {{ shift.shiftName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Operator -->
        <div class="col-md-1">
          <div class="form-group">
            <label>Operator</label>
            <select class="form-control custom-select"
              [(ngModel)]="selectedoperator"
              name="operatorName"
              (ngModelChange)="select_operator()">
              <option *ngFor="let op of operatorData" [ngValue]="op.name">
                {{ op.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Date Range Preset -->
        <div class="col-md-1">
          <div class="form-group">
            <label>Date Range</label>
            <select class="form-control custom-select"
              [(ngModel)]="selectedDateRange"
              name="dateRange"
              (ngModelChange)="onDateChange($event)">
              <option value="Yesterday">Yesterday</option>
              <option value="1weak">1-Week</option>
              <option value="15Days">15-Days</option>
              <option value="custome">Custom</option>
            </select>
          </div>
        </div>

        <!--
          ✅ From Date & To Date are shown ONLY when "Custom" is selected.
             For Yesterday / 1-Week / 15-Days the dates resolve automatically
             in the TS, so no UI pickers are needed and getData() fires instantly.
             For Custom, the user picks dates manually and then clicks Submit.
        -->
        <ng-container *ngIf="showCustomDate">

          <!-- From Date (Custom only) -->
          <div class="col-md-2">
            <div class="form-group">
              <label>From Date</label>
              <input class="form-control"
                type="date"
                [(ngModel)]="fromDate"
                [min]="mindate"
                [max]="maxdate"
                (change)="onFromDateChange()" />
            </div>
          </div>

          <!-- To Date (Custom only) -->
          <div class="col-md-2">
            <div class="form-group">
              <label>To Date</label>
              <input class="form-control"
                type="date"
                [(ngModel)]="toDate"
                [min]="fromDate"
                [max]="maxToDate"
                (change)="changeMax()" />
              <small class="text-muted">Max 30-day range</small>
            </div>
          </div>

        </ng-container>

        <!-- Submit (always visible; required for Custom date range) -->
        <div class="col-md-1">
          <button
            style="margin-top: 1.8rem; width: 100%"
            class="btn btn-success btn-rounded"
            type="button"
            [disabled]="isLoading"
            (click)="getData()">
            <span *ngIf="!isLoading">Submit</span>
            <span *ngIf="isLoading">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
          </button>
        </div>

        <!-- Export — visible only when table has data -->
        <div class="col-md-1" *ngIf="showTable && tableData.length > 0">
          <button
            style="margin-top: 1.8rem; width: 100%"
            class="btn btn-primary btn-rounded"
            type="button"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')">
            Export
          </button>
        </div>

      </div><!-- /filter row -->
    </div>
  </div>

  <div class="row">
        <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div
            [options]="performanceChart"
            (chartInit)="onperfChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 150px"
            echarts
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Table ───────────────────────────────────────────────────────────── -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="showTable && tableData.length > 0" class="table-responsive">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
              <thead class="thead-dark">
                 <tr>
                  <th>Date</th>
                  <th>Machine Name</th>
                  <th>Operator Name</th>
                  <th>Available Time (hrs)</th>
                  <th>Running (hrs)</th>
                  <th>Idle (hrs)</th>
                  <th *ngIf="hasBreakdown">Breakdown (hrs)</th>
                  <th *ngIf="hasInterlock">Interlock (hrs)</th>
                  <th>Off</th>
                  <th>Downtime (hrs)</th>
                  <th>Qty Planned</th>
                  <th *ngIf="!hasPin2">Qty Produced</th>
                  <th *ngIf="hasPin2">Partcount 1</th>
                  <th *ngIf="hasPin2">Partcount 2</th>
                  <th>Availability(%)</th>
                  <th>Performance(%)</th>
                  <th>Quality(%)</th>
                  <th>Oee(%)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of tableData
                      | slice : pageSize
                      | slice : 0 : itemsPerPage;">
                   <td>{{ data.date ? data.date : "--" }}</td>
                   <td>{{ data.deviceName ? data.deviceName: "--" }}</td>
                  <td>{{ data.operatorName ? data.operatorName : "--" }}</td>
                  <td>{{ data.availableTime ? data.availableTime : "00:00:00" }}</td>
                  <td>{{ data.running ? data.running : "00:00:00" }}</td>
                  <td>{{ data.idle ? data.idle : "00:00:00" }}</td>
                  <td *ngIf="hasBreakdown">{{ data.breakdown ? data.breakdown : "00:00:00" }}</td>
                  <td *ngIf="hasInterlock">{{ data.interlock ? data.interlock : "00:00:00" }}</td>
                  <td>{{ data.off ? data.off : "00:00:00" }}</td>
                  <td>{{ data.downtime ? data.downtime : "00:00:00" }}</td>
                  <td>{{ data.partPlanned ? data.partPlanned : 0 }}</td>
                  <td *ngIf="!hasPin2">{{ data.pin1_count ? data.pin1_count : 0 }}</td>
                  <td *ngIf="hasPin2">{{ data.pin1_count ? data.pin1_count : 0 }}</td>
                  <td *ngIf="hasPin2">{{ data.pin2_count ? data.pin2_count : "NA" }}</td>
                  <td>{{ data.availability || 0 }}</td>
                  <td>{{ data.performance || 0 }}</td>
                  <td>{{ data.quality || 0 }}</td>
                  <td>{{ data.oee || 0 }}</td>
                </tr>
              </tbody>
            </table>
             <div class="col-md-6" *ngIf="tableData?.length > itemsPerPage">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="tableData?.length"
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>
          <div
            *ngIf="showTable && (!tableData || tableData.length === 0)"
            class="text-center text-muted"
          >
            No data available for the selected Date and Department, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>

</div><!-- /container-fluid -->


<!-- ══════════════════════════════════════════════════════════════════════════
     Export Modal
══════════════════════════════════════════════════════════════════════════ -->
<ng-template #templatepdf let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body card-body">
    <div class="example-container">

      <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills nav-justified">

        <li [ngbNavItem]="1" (click)="directExpo()">
          <a ngbNavLink><h6>Direct Export</h6></a>
          <ng-template ngbNavContent>
            <ng-container [ngTemplateOutlet]="directExport"></ng-container>
          </ng-template>
        </li>

        <li [ngbNavItem]="2" (click)="mailexport()">
          <a ngbNavLink><h6>Export via Email</h6></a>
          <ng-template ngbNavContent>
            <ng-container [ngTemplateOutlet]="mailExport"></ng-container>
          </ng-template>
        </li>

      </ul>

      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>

      <div class="text-right mt-3">
        <button *ngIf="!exportViaMail"
          type="button"
          class="btn btn-info round waves-effect"
          (click)="closeModal(); download()">
          Export
        </button>
        <button *ngIf="exportViaMail"
          type="button"
          class="btn btn-info round waves-effect"
          [disabled]="!mailform.get('email')?.value || isEmailInvalid()"
          (click)="closeModal(); download()">
          Export
        </button>
      </div>

    </div>
  </div>
</ng-template>


<!-- ── Direct Export tab content ─────────────────────────────────────────── -->
<ng-template #directExport>
  <div class="mt-3">
    <p>Select the file type you would like to export</p>
    <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }">
      <i class="fas fa-file-pdf" (click)="pdf()"> PDF </i>
    </span>&nbsp;&nbsp;
    <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }">
      <i class="fas fa-file-csv" (click)="csv()"> CSV </i>
    </span>
  </div>
</ng-template>


<!-- ── Email Export tab content ──────────────────────────────────────────── -->
<ng-template #mailExport>
  <div class="mt-3">
    <p>Select the file type you would like to export</p>
    <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }">
      <i class="fas fa-file-pdf" (click)="pdf()"> PDF </i>
    </span>&nbsp;&nbsp;
    <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }">
      <i class="fas fa-file-csv" (click)="csv()"> CSV </i>
    </span>

    <form [formGroup]="mailform" class="mt-3">
      <div class="form-group col-md-8">
        <label>Email Address</label>
        <input class="form-control"
          id="email"
          placeholder="user@gmail.com"
          formControlName="email"
          [ngClass]="{ 'is-invalid': isEmailInvalid() }" />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email?.hasError('required')" class="text-danger">Email is required</span>
          <span *ngIf="email?.hasError('email')" class="text-danger">Invalid email address</span>
        </div>
      </div>
    </form>
  </div>
</ng-template>